import { render, staticRenderFns } from "./bottom-btn.vue?vue&type=template&id=196700ff&scoped=true&"
import script from "./bottom-btn.vue?vue&type=script&lang=js&"
export * from "./bottom-btn.vue?vue&type=script&lang=js&"
import style0 from "./bottom-btn.vue?vue&type=style&index=0&id=196700ff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196700ff",
  null
  
)

export default component.exports